import { type ReactNode } from 'react';
import clsx from 'clsx';
import { PaletteUtils } from '@shared/utils';
import { Header } from '../../header';
import { Footer } from '../../footer';

interface InnerPageLayoutProps {
  children: ReactNode;
}

export const InnerPageLayout = (props: InnerPageLayoutProps) => {
  return (
    <>
      <div
        className={clsx(
          'min-h-screen flex flex-col min-lg:min-h-full min-lg:relative min-lg:border-collapse min-lg:table min-lg:max-w-[100vw] min-lg:w-full',
          PaletteUtils.isBordierPalette ? 'bg-white font-[Arial]' : 'bg-[#27272b] font-[Avenir,sans-serif]',
        )}
      >
        <div className='min-lg:table-row min-lg:h-0'>
          <div className='min-lg:table-cell'>
            <Header className='w-full' />
          </div>
        </div>
        <div className='flex-grow min-lg:table-row'>
          <div className='min-lg:table-cell min-lg:h-full'>
            <div className='text-[#4d3b2c] max-w-[1280px] my-0 mx-auto px-2.5 max-[840px]:p-0'>{props.children}</div>
          </div>
        </div>
        <div className='min-lg:table-row min-lg:h-0'>
          <div className='min-lg:table-cell'>
            <Footer />
          </div>
        </div>
      </div>
    </>
  );
};
